import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseAdvisorInfoModel} from '@models/api/@base/base-advisor-info.model';
import {ProfileModel} from '@models/api/advisor/profile.model';
import {FileDownloaderService} from '@services/file-downloader.service';
import {environment} from 'environments/environment';
import {Observable} from 'rxjs';

@Injectable({providedIn: 'root'})
export class ApiAdvisorService {

    constructor(
        private httpClient: HttpClient,
        private fileDownloaderService: FileDownloaderService,
    ) {
    }

    /**
     * Get Primary profile
     */
    public getPrimary(): Observable<BaseAdvisorInfoModel> {
        return this.httpClient
            .get<BaseAdvisorInfoModel>(`${environment.BaseApiUrl}/Advisor/GetPrimary`);
    }

    /**
     * Get Advisor avatar
     */
    public getAvatar(): Observable<string> {
        return this.fileDownloaderService
            .downloadDataAsBase64(`${environment.BaseApiUrl}/Advisor/GetAvatar`);
    }

    /**
     * Get User avatar
     */
    public getUserAvatar(): Observable<string> {
        return this.fileDownloaderService
            .downloadDataAsBase64(`${environment.BaseApiUrl}/Advisor/GetUserAvatar`);
    }

    /**
     * Get user advisor profile
     */
    public getUserAdvisor(): Observable<BaseAdvisorInfoModel> {
        return this.httpClient
            .get<BaseAdvisorInfoModel>(`${environment.BaseApiUrl}/Advisor/GetUserAdvisor`);
    }

    /**
     * Get user profiles
     */
    public getProfiles(): Observable<ProfileModel[]> {
        return this.httpClient
            .get<ProfileModel[]>(`${environment.BaseApiUrl}/Advisor/GetProfiles`);
    }

    /**
     * Set user profile
     * @param advisorId
     */
    public setProfile(advisorId: string): Observable<ProfileModel> {
        return this.httpClient
            .get<ProfileModel>(`${environment.BaseApiUrl}/Advisor/SetPrimary?advisorId=${advisorId}`);
    }

    /**
     * Get Advisor avatar
     */
    public getAvatarAdvisor(advisorId: string): Observable<string> {
        return this.fileDownloaderService
            .downloadDataAsBase64(`${environment.BaseApiUrl}/Advisor/GetAvatar/${advisorId}`);
    }

}
